export const ntHeroSlides = [
  {
    id: 1,
    tag: "AUTOMAÇÃO INDUSTRIAL",
    title: "Transformamos ideias em soluções industriais de alto desempenho.",
    subtitle: "Máquinas especiais, equipamentos sob medida e automação para grandes indústrias.",
    cta1: "Conheça Nossas Soluções",
    cta2: "Fale com um Especialista",
    image: "https://readdy.ai/api/search-image?query=modern%20industrial%20factory%20interior%20bright%20clean%20automated%20machinery%20production%20line%20professional%20manufacturing%20plant%20high%20tech%20white%20background&width=1400&height=700&seq=nthero1&orientation=landscape",
  },
  {
    id: 2,
    tag: "MÁQUINAS ESPECIAIS",
    title: "Engenharia de precisão para os maiores desafios industriais.",
    subtitle: "Do projeto à entrega, desenvolvemos equipamentos personalizados para cada necessidade.",
    image: "https://readdy.ai/api/search-image?query=industrial%20precision%20CNC%20machine%20tools%20bright%20clean%20factory%20floor%20professional%20manufacturing%20equipment%20modern%20facility&width=1400&height=700&seq=nthero2&orientation=landscape",
    cta1: "Ver Produtos",
    cta2: "Solicitar Orçamento",
  },
  {
    id: 3,
    tag: "INOVAÇÃO & TECNOLOGIA",
    title: "Referência em soluções industriais personalizadas.",
    subtitle: "Atuamos nos segmentos metalúrgico, têxtil, alimentício, automobilístico e higiene pessoal.",
    image: "https://readdy.ai/api/search-image?query=smart%20factory%20automation%20control%20system%20industrial%20technology%20bright%20clean%20modern%20manufacturing%20plant%20professional&width=1400&height=700&seq=nthero3&orientation=landscape",
    cta1: "Nossos Cases",
    cta2: "Sobre a Empresa",
  },
];

export const ntDiferenciais = [
  { id: 1, icon: "ri-settings-3-line", title: "Soluções Sob Medida", desc: "Cada projeto é desenvolvido exclusivamente para as necessidades do cliente, garantindo máxima eficiência." },
  { id: 2, icon: "ri-shield-check-line", title: "Qualidade Certificada", desc: "Processos rigorosos de controle de qualidade em todas as etapas de fabricação e entrega." },
  { id: 3, icon: "ri-team-line", title: "Equipe Especializada", desc: "Máxima eficiência, especialistas e técnicos altamente treinados com mais de 10 anos de experiência." },
  { id: 4, icon: "ri-time-line", title: "Entrega no Prazo", desc: "Comprometimento total com cronogramas e prazos acordados com cada cliente." },
  { id: 5, icon: "ri-global-line", title: "Atuação Nacional", desc: "Presença em todo o Brasil, atendendo os maiores grupos industriais do país." },
  { id: 6, icon: "ri-customer-service-2-line", title: "Suporte Contínuo", desc: "Assistência técnica especializada e suporte pós-venda para garantir a operação contínua." },
];

export const ntServices = [
  { id: 1, icon: "ri-cpu-line", title: "Automação Industrial", subtitle: "New Tech Solution", desc: "Sistemas de automação inteligentes para otimizar processos, reduzir custos e aumentar a produtividade da sua linha de produção." },
  { id: 2, icon: "ri-tools-line", title: "Fabricação de Máquinas Especiais", subtitle: "New Tech Solution", desc: "Desenvolvimento e fabricação de máquinas e equipamentos especiais totalmente personalizados para cada segmento industrial." },
  { id: 3, icon: "ri-settings-line", title: "Acessórios para Equipamentos", subtitle: "New Tech Solution", desc: "Linha completa de acessórios e componentes industriais de alta performance para manutenção e upgrade de equipamentos." },
];

export const ntProducts = [
  {
    id: 1,
    category: "Alimentício",
    name: "Picolezeira Industrial Automática",
    desc: "Equipamento de alta capacidade para produção de picolés, desenvolvido sob medida para o setor alimentício.",
    image: "https://readdy.ai/api/search-image?query=industrial%20ice%20cream%20popsicle%20machine%20stainless%20steel%20food%20processing%20equipment%20professional%20clean%20white%20background%20bright&width=500&height=380&seq=ntprod1&orientation=landscape",
  },
  {
    id: 2,
    category: "Metalúrgico",
    name: "Prensa Hidráulica CNC",
    desc: "Prensa hidráulica de alta precisão com controle CNC para conformação de metais em larga escala.",
    image: "https://readdy.ai/api/search-image?query=hydraulic%20CNC%20press%20machine%20industrial%20metal%20forming%20equipment%20heavy%20machinery%20clean%20bright%20background%20professional&width=500&height=380&seq=ntprod2&orientation=landscape",
  },
  {
    id: 3,
    category: "Têxtil",
    name: "Calandra de Sublimação Industrial",
    desc: "Calandra de alta performance para sublimação têxtil com controle preciso de temperatura e pressão.",
    image: "https://readdy.ai/api/search-image?query=industrial%20sublimation%20calender%20textile%20machine%20large%20roller%20heat%20press%20professional%20manufacturing%20clean%20bright%20background&width=500&height=380&seq=ntprod3&orientation=landscape",
  },
  {
    id: 4,
    category: "Automobilístico",
    name: "Robô de Soldagem Automatizado",
    desc: "Sistema robótico de soldagem para linhas automotivas com alta precisão e velocidade de produção.",
    image: "https://readdy.ai/api/search-image?query=industrial%20welding%20robot%20arm%20automotive%20production%20line%20automated%20manufacturing%20bright%20clean%20factory%20professional&width=500&height=380&seq=ntprod4&orientation=landscape",
  },
  {
    id: 5,
    category: "Higiene Pessoal",
    name: "Linha de Envase Automático",
    desc: "Sistema completo de envase e embalagem para produtos de higiene pessoal com alta velocidade e precisão.",
    image: "https://readdy.ai/api/search-image?query=automatic%20filling%20packaging%20machine%20personal%20care%20products%20industrial%20production%20line%20clean%20stainless%20steel%20bright%20professional&width=500&height=380&seq=ntprod5&orientation=landscape",
  },
  {
    id: 6,
    category: "Automação",
    name: "Painel de Controle Industrial",
    desc: "Painéis elétricos e de controle customizados para automação de processos industriais complexos.",
    image: "https://readdy.ai/api/search-image?query=industrial%20control%20panel%20electrical%20cabinet%20automation%20PLC%20system%20professional%20clean%20bright%20background%20technology&width=500&height=380&seq=ntprod6&orientation=landscape",
  },
];

export const ntTestimonials = [
  {
    id: 1,
    name: "Fernando Luiz Bello",
    role: "Diretor",
    company: "Arte e Laço Indústria Têxtil",
    text: "Hoje a New Tech Solution é fundamental em nosso dia a dia, seus serviços de tecnologia fazem com que possamos melhorar nossos equipamentos e processos internos, ganhando eficiência produtiva.",
    avatar: "https://i.ibb.co/ZzV8MnKZ/2f17c53a-acc7-4c3f-9ae4-c693daaca539.jpg",
  },
  {
    id: 2,
    name: "Julio Alexandro Reiter",
    role: "Coordenador de Engenharia",
    company: "VIVEO • Cremer",
    text: "Temos uma experiência excelente com a  ew Tech na resolução dos desafios industriais internos das nossas fábricas. Gosto muito da versatilidade, atendimento, prazos de atendimento e a qualidade das suas entregas. Sem dúvidas um ótimo parceiro que queremos ter por muitos anos ao nosso lado.",
    avatar: "https://i.ibb.co/d4CtmdkN/c8c29529-30bd-4af5-b94b-dbb7a81a9425.jpg",
  },
  {
    id: 3,
    name: "Erivan Marcos Adami",
    role: "Sócio Diretor",
    company: "Adantex.",
    text: "A automação realizada pela New Tech trouxe excelentes resultados para a nossa empresa. Conseuimos aumentar significativamente a nossa produção, otimizar processos e ganhar mais eficiência no dia a dia. Sem dúvida, foi um ótimo investimento. Além da qualidade do serviço prestado, a equipe sempre se mostrou muito atenciosa, prestativa e comprometida em atender nossas necessidades com agilidade e profissionalismo. A entrega foi realizada dentro do prazo combinado, demonstrando seriedade e responsabilidade em cada etapa do projeto. Estamos muito satisfeitos com o trabalho realizado e recomendamos a empresa pela competência, qualidade técnica e excelente atendimento.",
    avatar: "https://i.ibb.co/fzjkdjC3/678a4202-25b1-44f6-8c48-8ceba799a227.jpg",
  },
];

export const ntClients = [
  { id: 1, name: "Grupo Alfa", logo_url: "https://readdy.ai/api/search-image?query=modern%20industrial%20company%20logo%20minimal%20clean%20professional%20dark%20text%20white%20background%20simple%20bold%20typography%20manufacturing&width=200&height=80&seq=ntclient1&orientation=landscape", website: "https://example.com" },
  { id: 2, name: "Têxtil Horizonte", logo_url: "https://readdy.ai/api/search-image?query=textile%20company%20logo%20minimal%20clean%20professional%20dark%20text%20white%20background%20simple%20bold%20typography%20fabric%20industry&width=200&height=80&seq=ntclient2&orientation=landscape", website: "https://example.com" },
  { id: 3, name: "Alimentos Premium", logo_url: "https://readdy.ai/api/search-image?query=food%20company%20logo%20minimal%20clean%20professional%20dark%20text%20white%20background%20simple%20bold%20typography%20food%20industry%20premium&width=200&height=80&seq=ntclient3&orientation=landscape", website: "https://example.com" },
  { id: 4, name: "AutoParts Brasil", logo_url: "https://readdy.ai/api/search-image?query=automotive%20parts%20company%20logo%20minimal%20clean%20professional%20dark%20text%20white%20background%20simple%20bold%20typography%20auto%20industry&width=200&height=80&seq=ntclient4&orientation=landscape", website: "https://example.com" },
  { id: 5, name: "Higiene Total", logo_url: "https://readdy.ai/api/search-image?query=personal%20care%20company%20logo%20minimal%20clean%20professional%20dark%20text%20white%20background%20simple%20bold%20typography%20hygiene%20industry&width=200&height=80&seq=ntclient5&orientation=landscape", website: "https://example.com" },
  { id: 6, name: "MetalTech", logo_url: "https://readdy.ai/api/search-image?query=metal%20technology%20company%20logo%20minimal%20clean%20professional%20dark%20text%20white%20background%20simple%20bold%20typography%20metallurgy&width=200&height=80&seq=ntclient6&orientation=landscape", website: "https://example.com" },
  { id: 7, name: "IndústriaMax", logo_url: "https://readdy.ai/api/search-image?query=industrial%20company%20logo%20minimal%20clean%20professional%20dark%20text%20white%20background%20simple%20bold%20typography%20manufacturing%20max&width=200&height=80&seq=ntclient7&orientation=landscape", website: "https://example.com" },
  { id: 8, name: "FabriCorp", logo_url: "https://readdy.ai/api/search-image?query=fabrication%20corporation%20logo%20minimal%20clean%20professional%20dark%20text%20white%20background%20simple%20bold%20typography%20industrial%20corp&width=200&height=80&seq=ntclient8&orientation=landscape", website: "https://example.com" },
];

export const ntCases = [
  {
    id: 1,
    category: "Alimentício",
    title: "Picolezeira Automática para Grupo Alimentício",
    desc: "Desenvolvimento de linha completa de produção de picolés com capacidade de 10.000 unidades/hora.",
    image: "https://readdy.ai/api/search-image?query=food%20processing%20factory%20ice%20cream%20production%20line%20industrial%20automated%20machinery%20stainless%20steel%20professional%20clean%20bright&width=600&height=400&seq=ntcase1&orientation=landscape",
    result: "+300% produtividade",
  },
  {
    id: 2,
    category: "Têxtil",
    title: "Automação Completa de Linha Têxtil",
    desc: "Modernização e automação de linha de produção têxtil com integração de sistemas de controle inteligente.",
    image: "https://readdy.ai/api/search-image?query=textile%20factory%20automation%20modernization%20production%20line%20machinery%20upgrade%20industrial%20technology%20bright%20clean%20professional&width=600&height=400&seq=ntcase2&orientation=landscape",
    result: "+40% eficiência",
  },
  {
    id: 3,
    category: "Metalúrgico",
    title: "Prensas CNC para Metalúrgica Nacional",
    desc: "Fornecimento de 12 prensas hidráulicas CNC customizadas para conformação de peças automotivas.",
    image: "https://readdy.ai/api/search-image?query=metal%20stamping%20press%20CNC%20hydraulic%20industrial%20manufacturing%20automotive%20parts%20production%20bright%20clean%20professional&width=600&height=400&seq=ntcase3&orientation=landscape",
    result: "12 máquinas entregues",
  },
];

export const ntNavLinks = [
  { label: "Home", href: "/" },
  { label: "Sobre", href: "/sobre" },
  { label: "Serviços", href: "/servicos" },
  { label: "Portfólio", href: "/portfolio" },
  { label: "Produtos", href: "/produtos" },
  { label: "Contato", href: "/contato" },
];
